import React, { Component } from "react";
import { Col, FormGroup, Row, Button } from "reactstrap";
import CommentsList from './CommentsList';
import './CommentsSection.css';
import autosize from 'autosize';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import axios from '../../../../../axios';
import * as url from '../../../../../utils/url';


export default class CommentsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allComments : [],
      displayComments : [],
      preview: false
    }
  }

  componentDidMount() {
    autosize(this.commentInput);
    let{toolDetails}=this.props
    axios.get(url.getToolkitComments(toolDetails._id)).then(({data}) => {
      console.log('data--- ', data.data)
      // const { comments } = data.data;
      let comments = data.data.comments
      this.setState({
        allComments : comments,
        displayComments : comments.slice(0,2)
      });
    });
  }

  handleCommentSubmit = () => {
    const commentText = this.commentInput.value;
    if(commentText.length > 0) {
      this.props.onAddComment(commentText);
      this.commentInput.value = "";
    }
  }

  render() {
    const {displayComments,allComments, preview} = this.state;

    return (
      <div className="container comment-section-container">
        <FormGroup row>
          <Col className="more-heading">Comments</Col>
        </FormGroup>
        <FormGroup className="mt20" row>
          <Col>
            <div className="inner-addon right-addon">
              {/* <span className="name-hint-max-length name-char-count-txt">0/150</span> */}
              <textarea
                type="text"
                name="comment"
                id="input-comment-toolkit"
                placeholder="Write a comment... "
                disabled={this.props.preview}
                ref={(c) => this.commentInput = c}
              />
              <Button className={''.concat(preview ? 'cursor-default disable-send-comment-button': 'send-comment-button').concat(' toolkit')} onClick={this.handleCommentSubmit}>
                <i className="send-icon flaticon-send"></i>
              </Button>
            </div>
          </Col>
        </FormGroup>
        <FormGroup row style={{'maxHeight':' 250px','overflow': 'auto'}}>
          <Col>
            <CommentsList
              allComments={preview ? [] : allComments}
              comments={preview ? [] : reverse(sortBy(displayComments,(o) => o.date))}
              onSeeMoreComments={this.props.onSeeMoreComments}
              onDeleteComment={this.props.onDeleteComment}
            />
          </Col>
        </FormGroup>
      </div>
    )
  }
}